import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getActiveNoteId } from 'data/ui/selectors'

import TargetModal from 'components/Integrations/ShareTo/TargetModal'
import { Consumer as SharedEventBusContextConsumer } from 'contexts/sharedEventBus'

// This component just hooks the TargetModal to the eventBusStore
class ShareToModal extends Component {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    eventBusStore: PropTypes.object.isRequired,
    createIntegrationTileBlock: PropTypes.func.isRequired,
  }

  state = {
    integration: null,
    selectedText: '',
    performAuthenticationOnly: false,
  }

  onPluginStateChange = ({ type, metadata }) => {
    if (type === 'showShareToModal') {
      this.setState({
        integration: metadata.integration,
        selectedText: metadata.selectedText,
        performAuthenticationOnly: metadata.performAuthenticationOnly,
      })
    }
  }

  componentDidMount() {
    this.props.eventBusStore.subscribeToItem('event', this.onPluginStateChange)
  }

  componentWillUnmount() {
    this.props.eventBusStore.unsubscribeFromItem(
      'event',
      this.onPluginStateChange
    )
  }

  render() {
    if (this.state.integration) {
      return (
        <TargetModal
          isOpen={true}
          noteId={this.props.noteId}
          integration={this.state.integration}
          selectedText={this.state.selectedText}
          performAuthenticationOnly={this.state.performAuthenticationOnly}
          createIntegrationTileBlock={this.props.createIntegrationTileBlock}
          onClose={() =>
            this.setState({
              integration: null,
            })
          }
          onSuccess={() =>
            this.setState({
              integration: null,
            })
          }
        />
      )
    }

    return null
  }
}

const enhance = connect(state => ({
  noteId: getActiveNoteId(state),
}))

function ShareToModalWithEventBusContextConsumer(props) {
  return (
    <SharedEventBusContextConsumer>
      {eventBusStore => (
        <ShareToModal {...props} eventBusStore={eventBusStore} />
      )}
    </SharedEventBusContextConsumer>
  )
}

export default enhance(ShareToModalWithEventBusContextConsumer)
